import { useContext } from "react";

import type { EventFilterScope } from "@/features/events/types/event-filter-scope";

import { EventFilterScopeContext } from "./event-filter-scope-context";

export const useEventFilterScope = (): EventFilterScope => {
	const scope = useContext(EventFilterScopeContext);
	if (scope === undefined) {
		throw new Error(
			"useEventFilterScope must be used within an EventFilterScopeProvider",
		);
	}
	return scope;
};
